import { render, staticRenderFns } from "./productDetailJoin.vue?vue&type=template&id=02bfcbc1&scoped=true&"
import script from "./productDetailJoin.vue?vue&type=script&lang=js&"
export * from "./productDetailJoin.vue?vue&type=script&lang=js&"
import style0 from "./productDetailJoin.vue?vue&type=style&index=0&id=02bfcbc1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bfcbc1",
  null
  
)

export default component.exports